<template>
  <div class="subcat-row">
    <div class="subcat-row-label" tabindex="0" role="button"
      @click="toggleIndicators"
      v-on:keyup.enter="toggleIndicators"
      v-on:keyup.space="toggleIndicators">
      <span>
        <i class="fa"
          :class="iconClass"></i>
      </span>
      <span class="current-subcat-title">{{subcategory.name}}</span>
    </div>
    <transition name="collapse">
      <indicator-block
      v-show="showIndicators" 
      :indicators="subcategory.indicators"
      :indicatorsColumnA="subcatColumnA.indicators"
      :indicatorsColumnB="subcatColumnB.indicators"
      :showIndicators="showIndicators">
      </indicator-block>
    </transition>
  </div>
</template>

<script>
import IndicatorScoreBlock from './IndicatorScoreBlock';
import { toggleIndicators } from '../../helpers/openCloseHelpers';

export default {
  name: 'subcat-row',
  props: ['subcategory', 'subcatColumnA', 'subcatColumnB'],
  components: {
    'indicator-block': IndicatorScoreBlock,
  },
  computed: {
    showIndicators() {
      return this.subcategory.showCurrentIndicators;
    },
    iconClass() {
      return this.showIndicators ? 'fa-caret-down' : 'fa-caret-right';
    },
  },
  methods: {
    toggleIndicators,
  },
};
</script>

<style lang="less">
  .current-subcat-title {
    font-weight: bold;
    font-size: 16px;
  }
  .subcat-row {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .subcat-row-label {
    cursor: pointer;
    padding-left: 3px;
    &:hover {
      background-color: #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// CurrentSubcatRow.vue?5e8360a4